export default __webpack_public_path__ + "7fe30d8ade6dfd66c1b4269717c0ae60.svg";